// Zugangsdaten per E-Mail (Edge portal-zugangsdaten) – nur auf Knopfdruck des Büros.
import { supabase } from '../supabase/client';

export interface ZugangsErgebnis { gesendet: boolean; grund?: string; an?: string; passwortGesetzt?: boolean }

export async function sendeZugangsdaten(p: { rolle: 'mieter' | 'eigentuemer'; id: string; passwort: string; neuSetzen: boolean }): Promise<ZugangsErgebnis> {
  const { data, error } = await supabase.functions.invoke('portal-zugangsdaten', { body: { rolle: p.rolle, id: p.id, passwort: p.passwort, neu_setzen: p.neuSetzen } });
  if (error) {
    let text = error.message;
    const ctx = (error as { context?: Response }).context;
    if (ctx && typeof ctx.json === 'function') { try { const j = await ctx.json(); if (j?.error) text = String(j.error); } catch { /* leer */ } }
    throw new Error(text);
  }
  return data as ZugangsErgebnis;
}

/** Text für die Rückmeldung im Büro. */
export function zugangsMeldung(r: ZugangsErgebnis, neu: boolean): string {
  if (r.gesendet) return `${neu ? 'Zugangsdaten' : 'Neues Passwort'} an ${r.an} gesendet`;
  return `${r.passwortGesetzt ? 'Passwort gesetzt, aber ' : ''}keine E-Mail verschickt: ${r.grund ?? 'unbekannt'}`;
}
